import { Checklist } from 'redux/checklistSlice';
import { IInspection } from 'redux/conductInspectionSlice';
import { Project, SubTask, Task } from 'redux/projectSlice';
import { IIncidents } from 'redux/services/incident';
import { IObservations } from 'redux/services/observation';

export const getInspectionDataForApi = (values: any) => ({
  id: values.id,
  projectId: values.projectId,
  subProject: values.subProject
    ? {
        name: values.subProject.name,
      }
    : undefined,
  subTask: values.subTask
    ? {
        name: values.subTask.name,
      }
    : undefined,
  endTask: values.endTask
    ? {
        name: values.endTask.name,
      }
    : undefined,
  selectedChecklist: values.selectedChecklist?._id
    ? {
        _id: values.selectedChecklist._id,
      }
    : undefined,
  locations: values.locations || undefined,
  selectedDoer: {
    userId: values.selectedDoer.userId || values.selectedDoer._id,
  },
});

export const getProjectDetailsFromObservationData = (
  observationData: IObservations | IIncidents,
  project?: Project,
) => {
  const subProject = observationData.subProject;
  const subTask = observationData.subTask;
  const endTask = observationData.endTask;

  const selectedDoer = observationData.doer
    ? project?.team.find((is) => is.userId === observationData.doer)
    : undefined;

  return {
    _id: observationData._id,
    subProject,
    subTask,
    endTask,
    selectedDoer,
  };
};

export const getProjectDetailsFromInspectionData = (
  inspection: IInspection,
  checklists: Checklist[],
  project?: Project,
) => {
  const subProject = inspection.subProject;
  const subTask = inspection.subTask;
  const endTask = inspection.endTask;

  const originalChecklist =
    inspection.checklistInfo?.checklistId && checklists.length
      ? checklists.find((c) => c._id === inspection.checklistInfo?.checklistId)
      : undefined;
  const selectedChecklist = {
    name:
      inspection.checklistInfo?.checklistName ?? originalChecklist?.name ?? '',
    _id: inspection.checklistInfo?.checklistId ?? originalChecklist?._id,
    data: originalChecklist?.data ?? inspection.response ?? {},
  };
  const selectedInspector = inspection.inspector
    ? project?.team.find((is) => is.userId === inspection.inspector)
    : undefined;
  const selectedDoer = inspection.doer
    ? project?.team.find((is) => is.userId === inspection.doer)
    : undefined;
  const locations = inspection.locations;
  const scheduledTime = inspection.scheduledDate;

  return {
    _id: inspection._id,
    subProject,
    subTask,
    endTask,
    selectedChecklist,
    selectedInspector,
    selectedDoer,
    locations,
    scheduledTime,
  };
};

export const getSupportedFilterOptionForAPI = (option: string) => {
  if (option === 'Sub Project') {
    return 'subProject';
  } else if (option === 'Tags') {
    return 'location';
  }

  return option.toLowerCase();
};

export const getAllSubTasks = (tasks: Task[]) => {
  const subProjects = tasks.map(({ name }) => ({ name }));
  const subTasksArr: SubTask[] = tasks
    .map(({ subtasks }) => subtasks)
    .flat()
    .filter((val) => val);
  const endTask = subTasksArr.map(({ tasks }) => tasks).flat();

  const result = [
    ...subProjects,
    ...subTasksArr.map(({ name }) => ({ name })),
    ...endTask,
  ];

  const set = new Set(result.map(({ name }) => name));

  return Array.from(set).map((name) => ({ name }));
};

export const getFilterValueByType = (
  option: any | null,
  filterByValue: any,
) => {
  if (filterByValue?.toLowerCase() === 'location') {
    return option?.name ?? '';
  } else if (filterByValue?.toLowerCase() === 'checklist') {
    return option?._id ?? '';
  } else if (filterByValue?.toLowerCase() === 'user') {
    return option?.userId ?? '';
  }

  return option?.name ?? '';
};
